import { CoralogixRum } from '@coralogix/browser';
import { getDeployment } from './appEnvironment';

const getRegion = () => getDeployment().region;

/**
 * Monitoring abstraction layer.
 * Currently backed by Coralogix RUM.
 * To switch providers, update only this file — all callers stay unchanged.
 */

/**
 * Identify the current user/tenant for session attribution.
 * Populates cx_rum.session_context.user_metadata with org_code and cloud_region.
 * app_instance_name is set automatically from application_name in the init config.
 */
export const setUserContext = ({ userId, orgCode } = {}) => {
  try {
    CoralogixRum.setUserContext({
      user_id: userId ? String(userId) : undefined,
      user_metadata: {
        ...(orgCode && { org_code: String(orgCode) }),
        cloud_region: getRegion()
      }
    });
  } catch (_) {
    /* ignore RUM errors */
  }
};

/** Track a custom event / action (e.g. API call metadata). */
export const trackEvent = (name, data) => {
  try {
    CoralogixRum.log(3, name, { ...data });
  } catch (_) {
    /* ignore RUM errors */
  }
};
